import { Alert, Card, Col, Collapse, Divider, Flex, Form, Radio, Row, Select, Tag } from "antd";
import React, { useEffect } from "react";
import Text from "../../components/Text/Text";
import Input from "../../components/Input/Input";
import { ActionBtnWhite } from "../../components/Button/TableActionButton";
import { color, icon } from "../../resource";
import {
  CaretRightOutlined,
  CheckOutlined,
  EnterOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import Button from "../../components/Button/Button";
import { roleDatasource } from "../../datasource/RoleDatasource";
import { onInputNumberKeyPress } from "../../utility/validator";

export const SequenceComponent = ({
  groupNo,
  index,
  form,
  roleList,
  onDeleteGroup,
  isEdit = false,
}: {
  groupNo: number;
  index: number;
  form: any;
  roleList: any;
  onDeleteGroup: any;
  isEdit?: boolean;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const getEmployeeInRole = async (roleName: string) => {
    const res = await roleDatasource
      .userInRole(profile?.company, roleName, "ACTIVE")
      .then((res) => res);
    return res;
  };
  const watchLimitCreditPercent = Form.useWatch("limitCreditPercent", form);
  const _watchGroup = Form.useWatch(["conditions", index], form);
  const conditions = form.getFieldValue("conditions") || [];

  const approvalList = form
    ?.getFieldValue(["conditions", index, "approvalList"])
    ?.map((item: any) => {
      return {
        ...item,
        label: `${item.firstname} ${item.lastname}`,
        value: `${item.userStaffId}`,
        key: `${item.userStaffId}`,
        userStaffName: `${item.firstname} ${item.lastname}`,
      };
    });
  const userInRole =
    form.getFieldValue(["conditions", index, "peopleInRole"])?.map((item: any) => {
      return {
        ...item,
        label: `${item.firstname} ${item.lastname}`,
        value: `${item.userStaffId}`,
        key: `${item.userStaffId}`,
        userStaffName: `${item.firstname} ${item.lastname}`,
      };
    }) || [];

  useEffect(() => {
    parseFloat(_watchGroup?.max) &&
      form.getFieldValue("limitCreditPercent") &&
      form.validateFields([["conditions", index, "max"]]);
  }, [_watchGroup?.max, form]);

  useEffect(() => {
    if (watchLimitCreditPercent) {
      form.setFieldValue(
        ["conditions", form.getFieldsValue(true)?.conditions?.length - 1, "max"],
        watchLimitCreditPercent,
      );
      form.validateFields([["conditions", index, "max"]]);
    } else {
      form.setFieldValue(
        ["conditions", form.getFieldsValue(true)?.conditions?.length - 1, "max"],
        undefined,
      );
      parseFloat(form.getFieldValue(["conditions", index, "max"])) &&
        form.validateFields([["conditions", index, "max"]]);
    }
  }, [watchLimitCreditPercent, form]);

  useEffect(() => {
    if (_watchGroup?.roleName) {
      mapAllApprovalList(
        _watchGroup.roleName,
        form.getFieldValue(["conditions", index, "roleId"]),
        false,
      );
    }
  }, [_watchGroup?.roleName]);

  const mapAllApprovalList = async (e: any, roleId: string, isChange: boolean) => {
    let list = await getEmployeeInRole(e);
    list = list.map((item: any, index: number) => {
      return { ...item, userStaffName: `${item.firstname} ${item.lastname}`, number: index + 1 };
    });

    form.setFieldsValue({
      ...form.getFieldsValue(true),
      conditions: form.getFieldsValue(true)?.conditions?.map((c: any, i: number) => {
        if (i === index) {
          return {
            ...c,
            roleId: roleId,
            peopleInRole: list,
            approvalList: approvalList && approvalList.length ? approvalList : list,
            maximumApproval: isChange ? list.length : c.maximumApproval || list.length,
          };
        } else {
          return {
            ...c,
            roleId: c.roleId,
          };
        }
      }),
    });
  };

  const onDeleteUser = (userStaffNumber: string) => {
    const conditions = form.getFieldValue("conditions");

    const updatedConditions = conditions.map((condition: any) => {
      if (condition.groupNo === groupNo) {
        form.resetFields([["conditions", groupNo - 1, "approvalList"]]);
        const updatedApprovalList = condition.approvalList
          .filter((user: any) => user.number !== userStaffNumber)
          .map((user: any, index: number) => ({ ...user, number: index + 1 }));

        return { ...condition, approvalList: updatedApprovalList };
      }
      return condition;
    });
    form.setFieldValue("conditions", updatedConditions);
  };

  const addUser = () => {
    const approvalList = form.getFieldValue(["conditions", index, "approvalList"]) || [];
    const pushData = [
      ...approvalList,
      {
        userStaffId: "",
        userStaffName: undefined,
        firstname: "",
        lastname: "",
        number: approvalList.length + 1,
      },
    ];
    form.setFieldValue(["conditions", index, "approvalList"], pushData);
  };

  const checkValidateMax = (groupNo: any, value: any) => {
    const valid = true;
    const message = "";
    const watchConditions = form.getFieldValue("conditions");
    const limit = form.getFieldValue("limitCreditPercent");
    const maxPrev = form.getFieldValue(["conditions", index - 1, "max"]);
    const maxNext = form.getFieldValue(["conditions", index + 1, "max"]);
    if (watchConditions.length !== groupNo) {
      if (value && maxPrev && parseFloat(value) <= parseFloat(maxPrev)) {
        return {
          valid: false,
          message: "วงเงินเกินสูงสุด (Max) ต้องสูงกว่าลำดับก่อนหน้า",
        };
      } else if (value && maxNext && parseFloat(value) >= parseFloat(maxNext)) {
        return {
          valid: false,
          message: "วงเงินเกินสูงสุด (Max) ต้องน้อยกว่าลำดับถัดไป",
        };
      }
    } else {
      return {
        valid: true,
        message: "",
      };
    }

    if (value && limit && parseFloat(value) > parseFloat(limit)) {
      return { valid: false, message: "วงเงินเกินสูงสุด (Max) ต้องไม่เกินเพดานของกฎนี้" };
    }
    return { valid: valid, message: message };
  };

  return (
    <Card
      title={
        <Row justify={"space-between"}>
          <Col>
            <Text fontWeight={600}>ลำดับที่ {groupNo}</Text>{" "}
            {groupNo === form.getFieldsValue(true)?.conditions?.length && (
              <Tag color='#EFF2F9' style={{ borderRadius: "8px" }}>
                <Text level={6}>ลำดับสุดท้าย</Text>
              </Tag>
            )}
          </Col>
          {form.getFieldValue("conditions")?.length > 1 && (
            <Col style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
              <ActionBtnWhite
                icon={<img src={icon.delete} style={{ width: 14, height: 16 }} />}
                onClick={() => onDeleteGroup(groupNo)}
              />
            </Col>
          )}
        </Row>
      }
    >
      {groupNo === 1 && (
        <Row justify={"space-between"} gutter={16}>
          <Col
            span={
              form.getFieldsValue(true)?.conditions?.length > 1 || watchLimitCreditPercent ? 12 : 24
            }
          >
            <Form.Item
              label='% วงเงินเกินต่ำสุด (Min)'
              name={["conditions", index, "min"]}
              rules={[{ required: true, message: "โปรดระบุ % วงเงินเกินต่ำสุด" }]}
              required
            >
              <Input
                prefix={form.getFieldsValue(true)?.conditions?.length === 1 ? ">" : undefined}
                placeholder='ระบุ % วงเงินเกินต่ำสุด'
                autoComplete='off'
                suffix='%'
                disabled={groupNo === 1}
                style={{ color: color.BK }}
              />
            </Form.Item>
          </Col>
          {(form.getFieldsValue(true)?.conditions?.length > 1 || watchLimitCreditPercent) && (
            <Col span={12}>
              <Form.Item
                label={
                  form.getFieldsValue(true)?.conditions?.length === 1 && watchLimitCreditPercent
                    ? "% เพดานวงเงินเกิน"
                    : "% วงเงินเกินสูงสุด (Max)"
                }
                name={["conditions", index, "max"]}
                rules={[
                  { required: true, message: "โปรดระบุ % วงเงินเกินสูงสุด" },
                  {
                    validator: (_, value) => {
                      if (parseFloat(value) === 0) {
                        return Promise.reject(new Error("วงเงินเกินสูงสุด (Max) ต้องการมากกว่า 0"));
                      }
                      if (
                        value &&
                        form.getFieldValue(["conditions", index + 1, "max"]) &&
                        parseFloat(form.getFieldValue(["conditions", index + 1, "max"])) <=
                          parseFloat(value)
                      ) {
                        return Promise.reject(
                          new Error("วงเงินเกินสูงสุด (Max) ต้องน้อยกว่าลำดับถัดไป"),
                        );
                      }

                      const limit = form.getFieldValue("limitCreditPercent");
                      if (value && limit && parseFloat(value) > parseFloat(limit)) {
                        return Promise.reject(
                          new Error("วงเงินเกินสูงสุด (Max) ต้องไม่เกินเพดานของกฎนี้"),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                required
              >
                <Input
                  placeholder='ระบุ % วงเงินเกินสูงสุด'
                  autoComplete='off'
                  suffix='%'
                  disabled={
                    form.getFieldsValue(true)?.conditions?.length === 1 && watchLimitCreditPercent
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    const conditions = form.getFieldValue("conditions");
                    if (conditions && conditions[index + 1]) {
                      form.setFieldValue(["conditions", index + 1, "min"], val);
                    }
                  }}
                  style={{ color: color.BK }}
                  onKeyDown={onInputNumberKeyPress}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      {groupNo !== 1 && (
        <Row justify={"space-between"} gutter={16}>
          <Col
            span={
              groupNo === form.getFieldsValue(true)?.conditions?.length && !watchLimitCreditPercent
                ? 24
                : 12
            }
          >
            <Form.Item
              label='% วงเงินเกินต่ำสุด (Min)'
              name={["conditions", index, "min"]}
              rules={[{ required: true, message: "โปรดระบุ % วงเงินเกินต่ำสุด" }]}
              required
            >
              <Input
                prefix='>'
                autoComplete='off'
                suffix='%'
                disabled
                style={{ color: color.BK }}
              />
            </Form.Item>
          </Col>
          {(groupNo !== form.getFieldsValue(true)?.conditions?.length ||
            watchLimitCreditPercent) && (
            <Col span={12}>
              <Form.Item
                label={
                  watchLimitCreditPercent && form.getFieldValue("conditions").length === groupNo
                    ? "% เพดานวงเงินเกิน"
                    : "% วงเงินเกินสูงสุด (Max)"
                }
                name={["conditions", index, "max"]}
                rules={[
                  { required: true, message: "โปรดระบุ % วงเงินเกินสูงสุด" },
                  {
                    validator: (_, value) => {
                      const res: any = checkValidateMax(groupNo, value);
                      if (res.valid) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(new Error(res.message));
                      }
                    },
                  },
                ]}
                required
              >
                <Input
                  placeholder='ระบุ % วงเงินเกินสูงสุด'
                  autoComplete='off'
                  suffix='%'
                  disabled={
                    watchLimitCreditPercent && form.getFieldValue("conditions").length === groupNo
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    const conditions = form.getFieldValue("conditions");
                    if (conditions && conditions[index + 1]) {
                      form.setFieldValue(["conditions", index + 1, "min"], val);
                    }
                  }}
                  style={{ color: color.BK }}
                  onKeyDown={onInputNumberKeyPress}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      <Row>
        <Col span={24}>
          <Form.Item
            name={["conditions", index, "roleName"]}
            label='บทบาทที่ต้องอนุมัติ'
            rules={[{ required: true, message: "เลือกบทบาทที่ต้องอนุมัติ" }]}
          >
            <Select
              placeholder='เลือกบทบาทที่ต้องอนุมัติ'
              options={roleList.filter(
                (r) =>
                  !conditions.some(
                    (c: any, currentIndex: number) =>
                      currentIndex !== index && c.roleName && c.roleName === r.value,
                  ),
              )}
              allowClear
              style={{ height: "40px" }}
              onChange={async (e, data: any) => {
                if (e) {
                  form.setFieldValue(["conditions", index, "approvalList"], []);
                  mapAllApprovalList(e, data.key, true);
                } else {
                  form.setFieldValue(["conditions", index, "roleId"], undefined);
                  form.setFieldValue(["conditions", index, "approveType"], undefined);
                  form.setFieldValue(["conditions", index, "maximumApproval"], undefined);
                  form.setFieldValue(["conditions", index, "approvalList"], []);
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      {_watchGroup?.roleName && (
        <Form.Item
          name={["conditions", index, "approveType"]}
          label='รูปแบบการอนุมัติ'
          rules={[{ required: true, message: "เลือกรูปแบบการอนุมัติ" }]}
        >
          <Radio.Group
            className='chart-radio-group'
            onChange={() =>
              mapAllApprovalList(
                _watchGroup.roleName,
                form.getFieldValue(["conditions", index, "roleId"]),
                true,
              )
            }
          >
            <Radio value='MINIMUM'>
              <Flex vertical>
                <Text fontWeight={600} level={6}>
                  อนุมัติตามจำนวนขั้นต่ำ
                </Text>
                <Text level={6} color='Text3'>
                  ผ่านการอนุมัติเมื่อมีผู้อนุมัติครบตามจำนวนขั้นต่ำที่กำหนด
                </Text>
              </Flex>
            </Radio>
            <Radio value='ALL'>
              <Flex vertical>
                <Text fontWeight={600} level={6}>
                  ต้องอนุมัติครบทุกคน
                </Text>
                <Text level={6} color='Text3'>
                  ทุกคนในบทบาทที่เลือกต้องอนุมัติทั้งหมด
                </Text>
              </Flex>
            </Radio>
          </Radio.Group>
        </Form.Item>
      )}
      {form.getFieldValue(["conditions", index, "approveType"]) === "MINIMUM" && (
        <>
          <Card style={{ backgroundColor: "#FAFAFA" }}>
            <Row style={{ paddingBottom: "15px" }}>
              <Text fontWeight={600} level={5}>
                ตั้งค่าเพิ่มเติม
              </Text>
            </Row>
            <Row>
              <Col span={10}>
                <Form.Item
                  name={["conditions", index, "maximumApproval"]}
                  label='จำนวนขั้นต่ำที่ต้องอนุมัติ (คน)'
                >
                  <Select
                    placeholder='เลือกจำนวนขั้นต่ำที่ต้องอนุมัติ'
                    options={form
                      ?.getFieldValue(["conditions", index, "peopleInRole"])
                      ?.map((e: any, index: number) => {
                        return {
                          label: `${index + 1}`,
                          value: `${index + 1}`,
                          key: `${index + 1}`,
                        };
                      })}
                    style={{ height: "40px" }}
                    onChange={() => {
                      const dataForm = form.getFieldValue(["conditions", index]);
                      if (`${dataForm.maximumApproval}` != `${dataForm.approvalList.length}`) {
                        const calUser =
                          parseInt(dataForm.maximumApproval) -
                          parseInt(dataForm.approvalList.length);
                        const mapUser: any = [];
                        if (calUser + dataForm.approvalList.length < dataForm.peopleInRole.length) {
                          mapUser.push(...dataForm.approvalList);
                          for (let i = 0; i < calUser; i++) {
                            mapUser.push({
                              userStaffId: "",
                              userStaffName: undefined,
                              firstname: "",
                              lastname: "",
                              number: i + 1,
                            });
                          }
                        } else {
                          mapUser.push(...dataForm.peopleInRole);
                        }
                        form.setFieldValue(["conditions", index, "approvalList"], mapUser);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider />
            <Form.Item
              name={["conditions", index, "approvalList"]}
              rules={[{ required: true, message: "เลือกชื่อผู้อนุมัติ" }]}
            >
              {form
                ?.getFieldValue(["conditions", index, "approvalList"])
                ?.map((approval: any, indexApproval: number) => {
                  return (
                    <>
                      <Row justify={"space-between"}>
                        <Col style={{ paddingTop: "10px" }}>
                          <EnterOutlined
                            style={{ transform: "scaleY(-1)  rotate(180deg)", fontSize: "18px" }}
                          />
                        </Col>
                        <Col style={{ paddingTop: "10px" }}>
                          <Text level={6}>ผู้อนุมัติคนที่ {indexApproval + 1}</Text>
                        </Col>
                        <Col span={20}>
                          <Form.Item
                            name={[
                              "conditions",
                              index,
                              "approvalList",
                              indexApproval,
                              "userStaffName",
                            ]}
                            rules={[{ required: true, message: "เลือกชื่อผู้อนุมัติ" }]}
                          >
                            <Select
                              placeholder='เลือกชื่อผู้อนุมัติ'
                              options={userInRole.filter(
                                (u: any) =>
                                  !approvalList?.some((w: any) => `${w.key}` === `${u.key}`),
                              )}
                              style={{ height: "40px" }}
                              onChange={(e, data: any) => {
                                const mapUser = {
                                  userStaffId: data.key,
                                  userStaffName: data.label,
                                  firstname: data.label.split(" ")[0],
                                  lastname: data.label.split(" ")[1],
                                  number: approval.number,
                                };
                                form.setFieldValue(
                                  ["conditions", index, "approvalList", indexApproval],
                                  mapUser,
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingTop: "3px" }}>
                          <ActionBtnWhite
                            icon={
                              <img
                                src={
                                  `${approvalList?.length}` === `${_watchGroup?.maximumApproval}`
                                    ? icon.deleteGray
                                    : icon.delete
                                }
                                style={{ width: 14, height: 16 }}
                              />
                            }
                            onClick={() =>
                              `${approvalList?.length}` !== `${_watchGroup?.maximumApproval}` &&
                              onDeleteUser(approval.number)
                            }
                          />
                        </Col>
                      </Row>
                    </>
                  );
                })}
            </Form.Item>
            <Row>
              <Col span={24}>
                <Button
                  typeButton={
                    `${approvalList?.length}` === `${userInRole?.length}`
                      ? "border-dashed-disabled"
                      : "border-dashed-primary"
                  }
                  style={{
                    height: "40px",
                  }}
                  title={"+ เพิ่มผู้อนุมัติ"}
                  onClick={() => `${approvalList?.length}` !== `${userInRole?.length}` && addUser()}
                />
              </Col>
            </Row>
          </Card>
          <br />
        </>
      )}
      {_watchGroup?.approveType && (
        <Collapse
          bordered={false}
          defaultActiveKey={["1"]}
          expandIconPosition='end'
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          style={{ background: "#F3F6F9" }}
          items={[
            {
              key: "1",
              label: (
                <Text fontWeight={600} level={6}>
                  สรุปการตั้งค่า
                </Text>
              ),
              children: (
                <>
                  <Col>
                    <CheckOutlined />{" "}
                    <Text level={6}>
                      {_watchGroup?.approveType === "ALL"
                        ? "ทุกคนในบทบาท"
                        : "จำนวนผู้อนุมัติที่ระบุในบทบาท"}{" "}
                      {_watchGroup?.roleName} ต้องอนุมัติคำขอนี้
                    </Text>
                  </Col>
                  <Col>
                    <CheckOutlined />{" "}
                    <Text level={6}>
                      {_watchGroup?.approveType === "ALL"
                        ? "จำนวนผู้อนุมัติทั้งหมด :"
                        : "จำนวนผู้อนุมัติขั้นต่ำ :"}{" "}
                      {_watchGroup?.maximumApproval ||
                        form?.getFieldValue(["conditions", index, "peopleInRole"])?.length}{" "}
                      คน
                    </Text>
                  </Col>
                  <Col>
                    <CheckOutlined /> <Text level={6}>ระบบจะส่งคำขอให้ทุกคนพร้อมกัน</Text>
                  </Col>
                  <Col>
                    <Alert
                      message={
                        <Text level={6}>
                          {_watchGroup?.approveType === "ALL" &&
                            "คำขอจะถูกอนุมัติก็ต่อเมื่อผู้อนุมัติทุกคนกดอนุมัติแล้ว"}{" "}
                          หากมีใครปฏิเสธ คำขอจะถูก Reject ทันที
                        </Text>
                      }
                      type='warning'
                      icon={<WarningOutlined style={{ fontSize: "16px" }} />}
                      showIcon
                      style={{ border: "none", backgroundColor: "#FFF8F5" }}
                    />
                  </Col>
                </>
              ),
            },
          ]}
        />
      )}
    </Card>
  );
};
